import React from 'react'
import {
  Link,
  MessageBar,
  MessageBarType,
  TextField,
} from 'office-ui-fabric-react'

export function TitleInput({
  title,
  setTitle,
  errorMessage,
  disabled,
}: {
  title: string
  setTitle: (title: string) => void
  errorMessage: string
  disabled: boolean
}) {
  return (
    <>
      <TextField
        label="Title"
        value={title}
        onChange={(_event, newTitle) => {
          setTitle(newTitle || '')
        }}
        disabled={disabled}
        required
        errorMessage={errorMessage}
      />
      <MessageBar messageBarType={MessageBarType.warning} isMultiline={true}>
        Titles in template mode support macros such as [bidder], [device] and
        [domain]. Full description
        <Link
          href="https://caroda.helpscoutdocs.com/article/42-title-templates"
          target="_blank"
        >
          here
        </Link>
        .
      </MessageBar>
    </>
  )
}
